import React, { useEffect, useState } from 'react'
import { IProps } from './types'
import { useStyles } from '../../style/styles'
import { AppBar, Box, IconButton, Menu, MenuItem, Toolbar, Tooltip, Typography, useMediaQuery } from '@mui/material'
import { connectToMessagingWebsocket, truncateText, WEBSOCKET_PRESENCE_MESSAGE } from '../../lib/messageUtils'
import { MessagingConstants } from '../../lib/enums'
import ContactSupportDialog from '../ContactSupportDialog'

function Navbar(props: IProps) {
    const classes = useStyles()
    const {
        receiver,
        job,
        userType,
        username,
        onEndConversation,
        isEndedConversation,
        token,
        connections,
        platform,
        deviceType,
        onTimezoneClick,
        onNotificationClick,
        userArn,
        endOrReenableActionDoer,
        channelMetadata,
        websocketConnection
    } = props
    const isMinimized = false
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const isMenuOpen = Boolean(anchorEl)
    const [status, setStatus] = useState<boolean>(false)
    const [isContactSupportOpen, setIsContactSupportOpen] = useState<boolean>(false)

    /* TJSKR-3131 ONLINE PRESENCE */
    useEffect(() => {
      if(websocketConnection && websocketConnection?.connectToWebsocket && process.env.REACT_APP_SHOW_PRESENCE === 'true') {
        const handlePresenceMessage = (message: any) => {
          if(message.type == WEBSOCKET_PRESENCE_MESSAGE) {
            const isMatchingUser = message.users.some((user: string) => user.split("+")[0] === receiver?.messaging_id)
            isMatchingUser ? setStatus(true) : setStatus(false)
          }
        }
        connectToMessagingWebsocket(websocketConnection, handlePresenceMessage)
      }
    }, [websocketConnection])

    const appLink = deviceType === 'web-ios' ? MessagingConstants.IOS_JS_APP_LINK
                  : deviceType === 'web-android' ? MessagingConstants.ANDROID_JS_APP_LINK
                  : MessagingConstants.WEB_JS_APP_LINK;

    const handleEndConversation = () => {
      onEndConversation(true)
      setAnchorEl(null)
    }

    const handleReEnableEndConversation = () => {
        onEndConversation(false)
        setAnchorEl(null)
    }

    const handleNotifications = () => {
      onNotificationClick()
      setAnchorEl(null)
    }

    const handleContactSupport = () => {
      setAnchorEl(null)
      setIsContactSupportOpen(true)
    }

    const getEllipsisIcon = () => {
      if(platform === 'mobile') {
        return connections?.isBlocked || connections?.isBlockedLink ? "/images/ellipsis-dark-disabled.svg" : "/images/ellipsis-dark.svg"
      } else {
        return connections?.isBlocked || connections?.isBlockedLink ? "/images/ellipsis-h-unsent.svg" : "/images/ellipsis-h.svg"
      }
    }

    const renderMenu = (
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right' }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={isMenuOpen}
        onClose={() => {setAnchorEl(null)}}
        sx={{
          zIndex: 9999,
          fontSize: '14px',
          fontFamily: 'Poppins',
          lineHeight: '22px',
          padding: '4px, 1px, 4px, 1px',
          minWidth: '400px'
        }}
      >
        {
          isEndedConversation ? (
          <MenuItem
            disabled={endOrReenableActionDoer == userArn ? false : true}
            onClick={handleReEnableEndConversation}
            sx={{ padding: '8px, 16px, 8px, 16px'}}
            >
            < Typography sx={{
              color: 'var(--primary-default-2-f-86-dd, #2F86DD)',
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '22px',
              padding: '8px, 16px, 8px, 16px'
            }} >
              Re-Enable Conversation
            </Typography>
          </MenuItem>
          ) : (
          <MenuItem
            onClick={handleEndConversation}>
            <Typography
              sx={{
                color: 'var(--danger-hover-focused-active-f-42-a-3-f, #F42A3F)',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '22px',
              }}
            >
              End Conversation
            </Typography>
          </MenuItem>
          )
        }
        { userType.toLowerCase() === 'jobseeker' && (
            <MenuItem onClick={handleNotifications}>
              <Typography
                sx={{
                  color: 'var(--primary-text-color, #000)',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: '22px',
                }}
              >
                Notifications
              </Typography>
            </MenuItem>
          )
        }
        <MenuItem>
          <a href={appLink}
            target="_blank"
            rel="noopener noreferrer" className={classes.noTextDecorations}>
            <Typography className={classes.noTextDecorations}>
              Register on the Jobtarget Jobseeker App
            </Typography>
          </a>
        </MenuItem>
        <MenuItem onClick={handleContactSupport}>
          <Typography className={classes.noTextDecorations}>
            Contact Support
          </Typography>
        </MenuItem>
      </Menu>
    )
    const fColor = platform === 'mobile' ? 'inherit' : 'default'
    return (
        <>
        <div
          className={classes.chatNavbar}>
            <AppBar
                position="static"
                sx={{
                  borderRadius: '8px 8px 0px 0px',
                  boxShadow: 'none',
                  border: platform == 'mobile' ? '0.5px solid #eae8e4' : 'none',
                  backgroundColor: platform == 'mobile' ? 'white' : '#2f86dd',
                  color: fColor,
                  height: '100%'
                }}>
                <Toolbar
                    sx={{
                    height: '100%',
                    padding: '16px 16px 16px 24px',
                    borderRadius: 'inherit',
                    backgroundColor: 'inherit',
                    color: 'inherit',
                    display: 'flex', 
                    alignItems: 'center'
                }}>
                    <Box sx={{ flexGrow: 1, maxWidth: isMinimized ? '150px':'auto' }}>
                      <Tooltip title={username} arrow>
                        <Typography                  
                            sx={{
                                fontSize: '16px',
                                fontWeight: '500',
                                fontFamily: 'Poppins',
                                color: platform === 'mobile' ? '#000' : '#fff',
                                marginBottom: '2px',
                                lineHeight: '20px'
                            }}
                        >
                          {truncateText(username, 20)}
                        </Typography>
                      </Tooltip>
                      {/* TJSKR-3352 Feature flag ONLINE PRESENCE IN PROD */}
                      { process.env.REACT_APP_SHOW_PRESENCE === 'true' && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <Box
                            sx={{
                              width: '6px',
                              height: '6px',
                              borderRadius: '50%',
                              backgroundColor: status ? '#4CAF50' : '#9E9E9E',
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: '11px',
                              fontWeight: '400',
                              fontFamily: 'Poppins',
                              color: platform === 'mobile' ? '#666' : 'rgba(255, 255, 255, 0.8)',
                              lineHeight: '14px'
                            }}
                          >
                            {status ? 'Online' : 'Offline'}
                          </Typography>
                        </Box>
                      )}
                      </Box>
                    <Box sx={{ display: { xs: 'flex', md: 'flex', gap: '0px' }}}>
                        {
                        !isMinimized && (
                          <>
                              <IconButton
                                  onClick={(e) => { setAnchorEl(e.currentTarget) }}
                                  sx={{width:'38px', height: '38px', '&:hover': { cursor: 'pointer' }}}
                                  disabled={connections?.isBlocked || connections?.isBlockedLink}
                              >
                                <img
                                  src={getEllipsisIcon()}
                                  alt="View more options"
                                  width={18}
                                  height={20}
                                />
                              </IconButton>
                            </>
                        )
                        }
                    </Box>
                </Toolbar>
            </AppBar>
              <>{renderMenu} </>
              <ContactSupportDialog
                open={isContactSupportOpen}
                onClose={() => setIsContactSupportOpen(false)}
                deviceType={deviceType}
              />
          </div>
        </>
    )
}

export default Navbar
